import routesPath from './RoutesPath';
import { SidePanelRouteState } from './types';

export const DEFAULT_SIDE_PANEL_ROUTE_STATE: SidePanelRouteState = {
  fromSidePanel: false,
  shouldAnimate: false,
  routedFromSecondaryPanel: false
};

export const FROM_SIDE_PANEL_ROUTE_STATE: SidePanelRouteState = {
  fromSidePanel: true,
  routedFromSecondaryPanel: false
};

export const ROOT_ROUTE_STATE: SidePanelRouteState = {
  shouldAnimate: true,
  routedFromSecondaryPanel: false
};

export const fullScreenRoutes = [
  routesPath.ACCOUNT_SETTINGS_MY_ACCOUNT,
  routesPath.ACCOUNT_SETTINGS_CREDITS_REWARDS,
  routesPath.INVOICES_CREATE,
  routesPath.INVOICES_PREVIEW,
  routesPath.INVOICES_EDIT_PREVIEW,
  routesPath.CREATE_INVITE,
  routesPath.TAXES_CREATE,
  routesPath.CATEGORIES_CREATE,
  routesPath.ITEMS_CREATE,
  routesPath.SERVICE_CHARGES_CREATE,
  routesPath.BANKING_ONBOARDING,
  routesPath.QUICKBOOKS_LOGIN,
  routesPath.QUICKBOOKS_SETTINGS,
  routesPath.BANK_APPLICATION_STATUS,
  routesPath.CONNECT_ONBOARDING,
  routesPath.CREATE_JOB,
  routesPath.ESTIMATES_CREATE,
  routesPath.CREATE_COMMISSION_RULE,
  routesPath.CREATE_TAG,
  routesPath.ADD_EXTERNAL_COMPANY,
  routesPath.ADD_SERVICE_AREA,
  routesPath.CREATE_TEAM
];

export const chatIconHiddenRoutes = [
  routesPath.INVOICES_CREATE,
  routesPath.CREATE_INVITE,
  routesPath.TAXES_CREATE,
  routesPath.ITEMS_CREATE,
  routesPath.SERVICE_CHARGES_CREATE,
  routesPath.CATEGORIES_CREATE,
  routesPath.QUICKBOOKS_LOGIN,
  routesPath.QUICKBOOKS_SETTINGS,
  routesPath.CREATE_JOB,
  routesPath.ESTIMATES_CREATE,
  routesPath.CREATE_TAG,
  routesPath.JOBS,
  routesPath.MAPS,
  routesPath.CUSTOMERS,
  routesPath.RECEIPTS,
  routesPath.BUSINESS_SUMMARY_REPORT,
  routesPath.SALES_SUMMARY_REPORT,
  routesPath.TAX_SUMMARY_REPORT
];

export const WEBVIEW_ROUTES = [
  routesPath.LENDICA_WEBVIEW,
  routesPath.CAPITAL_WEBVIEW,
  routesPath.ONBOARDING_CAPITAL_WEBVIEW,
  routesPath.CARD_DETAILS_WEBVIEW,
  routesPath.PIN_WEBVIEW,
  routesPath.CUSTOMER_ADD_COF_WEBVIEW,
  routesPath.APP_STORE_REDIRECT_WEBVIEW
];

// Routes that require Google Maps script
export const GOOGLE_MAPS_ROUTES = [routesPath.CUSTOMER_ADD_COF_WEBVIEW];

// Public routes that don't require authentication
export const PUBLIC_ROUTES = {
  exact: [
    routesPath.DEFAULT,
    routesPath.SIGNIN,
    routesPath.SIGN_UP,
    routesPath.SIGN_UP_QR,
    routesPath.RESET,
    routesPath.REDIRECT,
    routesPath.BLOCKED,
    routesPath.DECLINED,
    routesPath.WAITING_LIST,
    routesPath.CAPITAL_WEBVIEW,
    routesPath.ONBOARDING_CAPITAL_WEBVIEW
  ],
  includes: [
    routesPath.DIGITAL_ONBOARDING_NAME,
    routesPath.DIGITAL_ONBOARDING_EMAIL,
    routesPath.DIGITAL_ONBOARDING_PROFESSION,
    routesPath.DIGITAL_ONBOARDING_BUSINESS_NAME,
    routesPath.DIGITAL_ONBOARDING_EMPLOYEES,
    routesPath.DIGITAL_ONBOARDING_REFERRAL_SOURCE,
    routesPath.DIGITAL_ONBOARDING_WEBSITE,
    routesPath.DIGITAL_ONBOARDING_EMAIL_ERROR
  ]
};
